import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Genders } from "src/app/constants/genders";
import { MaskType } from "src/app/constants/masks";
import { USStates } from "src/app/constants/us-states";
import { AgentCompany, AgentCreateMemberModel, AgentCreateMemberPayload } from "src/app/models/agent";
import { ListItem } from "src/app/models/listItem";

import { FormValidationService } from "src/app/services/form-validation.service";
import { HelperService } from "src/app/services/helper.service";
import { LookupService } from "src/app/services/lookup.service";
import { MaskService } from "src/app/services/mask.service";

@Component({
    selector: 'mwp-member-create-form',
    templateUrl: './create-member-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateMemberFormomponent implements OnInit {
    @Input() public agentCreateMemberModel: AgentCreateMemberModel;
    @Output() public emitSave: EventEmitter<AgentCreateMemberPayload> = new EventEmitter();

    public maskType = MaskType;
    public usStates = USStates;
    public genders = Genders;
    public companies: AgentCompany[];
    public salaryFrequencies: ListItem[];

    public createMemberForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        private lookupService: LookupService,
        private helperService: HelperService,
        private maskService: MaskService,
    ) {
    }

    ngOnInit(): void {
        this.lookupService.getSalaryFrequencies().subscribe((response: ListItem[]) => {
            this.salaryFrequencies = response;
        });

        this.buildForm();
    }

    private buildForm(): void {
        this.createMemberForm = this.formBuilder.group({
            companyID: [''],
            firstName: ['', Validators.required],
            middleName: [''],
            lastName: ['', Validators.required],
            ssnDecrypted: ['', [Validators.required, Validators.compose([FormValidationService.validSSN(true)])]],
            dateOfBirth: ['', [Validators.required, Validators.compose([FormValidationService.validMaterialDate(true)])]],
            gender: ['', Validators.required],
            homeAddressLine1: ['', Validators.required],
            homeAddressLine2: [''],
            homeCity: ['', Validators.required],
            homeState: ['', Validators.required],
            homeZipCode: ['', [Validators.required, Validators.compose([FormValidationService.validZipcode(true)])]],
            homePhone: ['', FormValidationService.validPhoneNumber(false)],
            cellPhone: ['', FormValidationService.validPhoneNumber(false)],
            homeEmail: ['', [Validators.required, Validators.compose([FormValidationService.validEmail(true)])]],
            erid: ['', (this.agentCreateMemberModel.showErid ? Validators.required : null)],
            payrollNumber: ['', (this.agentCreateMemberModel.showPayrollNumber ? Validators.required : null)],
            workJobTitle: [''],
            employmentStatus: ['', (this.agentCreateMemberModel.availableEmploymentStatuses.length > 0 ? Validators.required : null)],
            dateOfHire: ['', [Validators.required, Validators.compose([FormValidationService.validMaterialDate(true)])]],
            workHours: ['', Validators.required],
            workPhone: ['', FormValidationService.validPhoneNumber(false)],
            workEmail: ['', FormValidationService.validEmail(false)],
            companyLocation: ['', (this.agentCreateMemberModel.showCompanyLocation ? Validators.required : null)],
            department: ['', (this.agentCreateMemberModel.showDepartment ? Validators.required : null)],
            position: ['', (this.agentCreateMemberModel.showPosition ? Validators.required : null)],
            division: ['', (this.agentCreateMemberModel.showDivision ? Validators.required : null)],
            salary1: ['0.00', FormValidationService.validCurrency(this.agentCreateMemberModel.showSalary1)],
            salary1Frequency: ['', (this.agentCreateMemberModel.showSalary1 ? Validators.required : null)],
            salary2: ['0.00', FormValidationService.validCurrency(this.agentCreateMemberModel.showSalary2)],
            salary2Frequency: ['', (this.agentCreateMemberModel.showSalary2 ? Validators.required : null)],
            salary3: ['0.00', FormValidationService.validCurrency(this.agentCreateMemberModel.showSalary3)],
            salary3Frequency: ['', (this.agentCreateMemberModel.showSalary3 ? Validators.required : null)],
            eEClass1: ['', (this.agentCreateMemberModel.showEEClass1 ? Validators.required : null)],
            eEClass2: ['', (this.agentCreateMemberModel.showEEClass2 ? Validators.required : null)],
            eEClass3: ['', (this.agentCreateMemberModel.showEEClass3 ? Validators.required : null)],
            eEClass4: ['', (this.agentCreateMemberModel.showEEClass4 ? Validators.required : null)],
            eEClass5: ['', (this.agentCreateMemberModel.showEEClass5 ? Validators.required : null)],
            udf1: [''],
            udf2: [''],
            udf3: [''],
            udf4: [''],
            udf5: [''],
        });
    }

    public save(): void {
        const l_AgentCreateMemberPayload: AgentCreateMemberPayload = this.helperService.convertFormGroupIntoObjectWithDefaultOverride(this.createMemberForm, new AgentCreateMemberPayload());
        l_AgentCreateMemberPayload.salary1 = this.maskService.removeCurrencyMask(l_AgentCreateMemberPayload.salary1.toString());
        l_AgentCreateMemberPayload.salary2 = this.maskService.removeCurrencyMask(l_AgentCreateMemberPayload.salary2.toString());
        l_AgentCreateMemberPayload.salary3 = this.maskService.removeCurrencyMask(l_AgentCreateMemberPayload.salary3.toString());

        this.emitSave.emit(l_AgentCreateMemberPayload);
    }
}